import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {
    ActionsRow,
    FixedDropDownButton,
    Icon,
    modal,
    utils,
    Loader,
    commons
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, DropdownItem, Row} from "reactstrap";
const {sinkEvent} = commons;
import {withRouter} from "react-router";
import * as opravneniActions from "../actions/opravneniActions";
import * as ciselnikActions from "../actions/ciselnikActions";
import NakladoveStrediskoForm from "../forms/NakladoveStrediskoForm";
import CiselnikApi from "../api/gen/cgo/CiselnikApi";
import UploadCsvForm from "../forms/UploadCsvForm";
import CiselnikCustomApi from "../api/CiselnikCustomApi";
import {toastr} from "react-redux-toastr";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující názvy objednávek společnosti.
 */
class NakladovaStrediskaPanel extends Component<WithTranslation> {

    static propTypes = {
        nakladovaStrediskaList: PropTypes.array.isRequired, // seznam nákladových středisek
        spolecnost: PropTypes.object.isRequired, // VO společnosti ke které názvy objednávek patří
        readOnly: PropTypes.bool, // zda bude panel read only, tj. nebudou zobrazeny editační akce, implicitně true
    };

    static defaultProps = {
        readOnly: true,
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
    };

    handleCreateNaklStred = () => {
        const {spolecnost, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            NakladoveStrediskoForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.createNaklStred(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateNakladovaStrediska());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {
                    spolecnost: spolecnost,
                }
            },
            t('order.new_name'),
            {size: "md"}
        ));
    };

    handleEditNaklStred = (naklStred) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            NakladoveStrediskoForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.updateNaklStred(data, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateNakladovaStrediska());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: naklStred
            },
            t('order.edit_name'),
            {size: "md"}
        ));
    };

    handleDeleteNaklStred = (naklStred) => {
        const {t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('order.delete_name'),
                <span>{t('order.delete_name_confirm', {name: <b>{naklStred.nazevStredisko}</b>})}</span>,
                () => {
                    CiselnikApi.deleteNaklStred(naklStred.id).then(() => {
                        this.props.dispatch(ciselnikActions.invalidateNakladovaStrediska());
                    });
                },
                null,
                t('delete')
            )
        );
    };

    handleNacistZCsv = () => {
        const {spolecnost, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            UploadCsvForm,
            {
                onSubmit: (data) => {
                    return CiselnikCustomApi.nactiSouborStrediska(spolecnost.id, data.obsahujeHlavicku, data.orezStrediskoKod, data.orezStrediskoNazev, data.oddelovac, data.soubor);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateNakladovaStrediska());
                    if (result !== null) {
                        toastr.info(result);
                    }
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {
                    obsahujeHlavicku: true,
                    orezStrediskoKod: false,
                    orezStrediskoNazev: true,
                    oddelovac: ";",
                }
            },
            t('order.load_from_csv'),
            {size: "sm"}
        ));
    };

    renderActions = () => {
        const {readOnly, t} = this.props;
        return <ButtonToolbar>
            {!readOnly && <Button onClick={this.handleCreateNaklStred}>{t('new_m')}</Button>}
            {!readOnly && <Button color="secondary" onClick={this.handleNacistZCsv}>{t('order.load_from_csv')}</Button>}
        </ButtonToolbar>
    };

    renderContextMenu = (naklStred) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="1" onClick={sinkEvent(this.handleEditNaklStred.bind(this, naklStred))}>{t('edit')}</DropdownItem>
            <DropdownItem key="2" onClick={sinkEvent(this.handleDeleteNaklStred.bind(this, naklStred))}>{t('delete')}</DropdownItem>
        </FixedDropDownButton>
    };

    render() {
        const {loggedInUser, nakladovaStrediskaList, readOnly, t} = this.props;

        if (!loggedInUser.fetched) {
            return <Loader/>;
        }

        return <Card className="nakladova-strediska-panel">
            <CardHeader>
                <ActionsRow actions={!readOnly ? this.renderActions() : null}>
                    <h2>{t('order.names')}</h2>
                </ActionsRow>
            </CardHeader>
            <div className="items-list">
                {nakladovaStrediskaList.length > 0 ? nakladovaStrediskaList.map(naklStred =>
                    <CardBody key={naklStred.id}>
                        <ActionsRow actions={!readOnly ? this.renderContextMenu(naklStred) : null} onClick={!readOnly ? this.handleEditNaklStred.bind(this, naklStred) : null}>
                            <Row>
                                <Col>
                                    {naklStred.nazevStredisko}
                                </Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>
                ) : <CardBody><i>{t('order.no_names')}</i></CardBody>}
            </div>
        </Card>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(NakladovaStrediskaPanel)));
